import { FunctionComponent } from 'react'

import { FreeRatioImageProps } from '.'
import { ActualImageDimensions } from './types'

export type MissingProps = Pick<
  FreeRatioImageProps,
  'className' | 'children'
> & {
  Placeholder: Required<FreeRatioImageProps>['Placeholder']
  actualDimensions: ActualImageDimensions
}

const Missing: FunctionComponent<MissingProps> = ({
  Placeholder,
  actualDimensions,
  className,
  children,
}) => (
  <Placeholder dimensions={actualDimensions} className={className}>
    {children}
  </Placeholder>
)

export default Missing
